import { html, render } from "lit-html";
import "./landingPage.css";
import "./landing-page-icon/css/fontello.css"
import logo from "./Aloitusruutu_Logo_Korjattu.png";
import { textContents } from "../textcontents";

export const LandingPage = (parameters) => {

    let copied = false;


    const markup = () => html`
    <div id="webview-detected">
      <img id="landari-logo" src=${parameters?.logo ? parameters.logo : logo} />
      <h2>${textContents.landingPage.openInBrowser} ! 👇</h2>
      <p>${window.navigator.userAgent.toLowerCase().indexOf("svtduo")}</p>
      <p class=${copied ? "landari-button landari-button-clicked" : "landari-button"} @click=${() => copyToClipboard(textContents.landingPage.link)}>${textContents.landingPage.link}</p>
      ${copied ? html`<p style="font-size: x-large; text-transform: uppercase;">${textContents.landingPage.copied}<i class="icon-ok"></i> </p>` : html`<p></p>`}
      </div>
    `;

    function copyToClipboard(text) {
        if (window.clipboardData && window.clipboardData.setData) {
            // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
            copied = true
            render(markup(), document.body);
            return clipboardData.setData("Text", text);
    
        }
        else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
            document.body.appendChild(textarea);
            textarea.select();
            try {
            copied = true
            render(markup(), document.body);
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            }
            catch (ex) {
                console.warn("Copy to clipboard failed.", ex);
                return false;
            }
            finally {
                document.body.removeChild(textarea);
                
            }
        }
       
    }

  render(markup(), document.body);
};